import React, { useEffect, useState } from "react";
import LandingNavBar from "./LandingNavBar";
import TextBannerArea from "./TextBannerArea";
import PhoneNumber from "./PhoneNumber";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import {
	actions,
	selectors,
	setAppUrl,
	setPreUrl,
} from "redux/container/authSlice";
import { setLanguage } from "config/language";
import FooterV2 from "./FooterV2";
import { baseUrl } from "config/apiUrl";
import SentOtpV2 from "./SentOtpV2";
import SectionHeader from "pages/Landing/SectionHeader";
import Blog from "services/Blog";
import SingleTask from "./SingleTask";
import Task from "services/Task";

export default function PhoneNumberCheck() {
	console.log("PhoneNumberCheck rendering");
	const { app, link } = useParams();
	const location = useLocation();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [countryCode, setCountryCode] = useState("+88");
	const [country, setCountry] = useState("Bangladesh");
	const [phoneNo, setPhoneNo] = useState("");
	var sSize = window.matchMedia("(max-width: 599px)");
	const { loginStatus } = useSelector(selectors.getAuth);
	const ekkLanguage = useSelector((state) => state?.lan?.lan);
	console.log("ekkLanguage:", ekkLanguage);
	var parts = location?.search?.split("?");

	useEffect(() => {
		// Redirect to home if already logged in
		if (loginStatus) {
			navigate("/home");
			return;
		}
	}, [loginStatus, navigate]);

	useEffect(() => {
		// Initialize app settings
		if (app === "ekkhero_pilot_log_in") {
			dispatch(setAppUrl({ app: app, link: baseUrl.ehp }));
		} else if (parts && parts[1]) {
			dispatch(actions.logout());
			localStorage.removeItem("master_token");
			localStorage.removeItem("_u");
			localStorage.removeItem("_b");
			localStorage.removeItem("cb");
			localStorage.setItem("auth", "false");
			dispatch(setPreUrl(parts[1]));
		} else {
			dispatch(setPreUrl(""));
		}
	}, []);

	if (localStorage.getItem("lan") === null) {
		setLanguage("bn");
	}

	const [taskList, setTaskList] = useState([]);
	const getTaskList = async () => {
		let blogList = await Task.getTasksPublic();
		if (blogList.status === 200) {
			setTaskList(blogList.results);
		}
	};

	useEffect(() => {
		getTaskList();
	}, []);

	// Show loading if language not ready
	if (!ekkLanguage || !ekkLanguage.task || !ekkLanguage.landing) {
		console.log("Language not ready yet");
		return (
			<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', backgroundColor: '#f9fafb' }}>
				<div>
					<div style={{ textAlign: 'center', marginBottom: '20px' }}>
						<img
							src='/assets/images/ekkhero_full_logo.png'
							alt='logo'
							style={{ width: '150px' }}
						/>
					</div>
					<div style={{ textAlign: 'center' }}>
						<div style={{
							width: '40px',
							height: '40px',
							border: '4px solid #f97316',
							borderTopColor: 'transparent',
							borderRadius: '50%',
							animation: 'spin 1s linear infinite',
							margin: '0 auto'
						}}></div>
						<p style={{ marginTop: '16px', color: '#666', fontSize: '16px' }}>Loading...</p>
					</div>
				</div>
			</div>
		);
	}

	return (
		<>
			<LandingNavBar />
			<div className='min-h-screen bg-gradient-to-br from-orange-50 via-white to-blue-50'>
				<div className='container'>
					<div className='flex flex-col lg:flex-row items-center justify-between pt-32 lg:pt-40 pb-16 gap-8'>
					<TextBannerArea ekkLanguage={ekkLanguage} />
					<PhoneNumber
						sSize={sSize}
						phoneNo={phoneNo}
						setPhoneNo={setPhoneNo}
						country={country}
						setCountry={setCountry}
						countryCode={countryCode}
						setCountryCode={setCountryCode}
					/>
					</div>
				</div>
			</div>
			<div className='bg-white py-20'>
				<div className='container'>
					<div className='text-center mb-12'>
						<h2 className='text-3xl md:text-4xl font-bold text-gray-800 mb-4'>{ekkLanguage.task.latestTask}</h2>
						<p className='text-gray-600 text-lg'>Join these opportunities to make a difference in your community</p>
					</div>
					<div className='grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3'>
							{taskList?.map((el, i) => {
								return <SingleTask item={el} key={i} />;
							})}
					</div>
					<div className='text-center pt-12'>
						<Link
							to='/task-list'
							className='inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-orange-500 to-orange-600 text-white text-lg font-bold rounded-full hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300'>
							{ekkLanguage.landing.seeMore}
							<svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
								<path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M17 8l4 4m0 0l-4 4m4-4H3' />
							</svg>
						</Link>
					</div>
				</div>
			</div>
			<FooterV2 />
		</>
	);
}
